import dayjs from '../plugins/dayjs';
// eslint-disable-next-line import/prefer-default-export
export const listRefunds = {
  data: () => ({
    refunds: [],
    refundsSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: '-createdAt',
      dateType: 'refundDate',
      startDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endDate: dayjs().subtract(1, 'month').endOf('month').format(),
      dynamicSearch: '',
    },
    refundsLoading: true,
    loadingCharge: false,
    refundState: null,
    refundsListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    refunds() {
      this.refundsLoading = false;
    },
  },
  methods: {
    async refundCharge({ chargeId, refundAmount }) {
      this.refundState = 'creating';
      const { errorCode } = await this.$store.dispatch('charges/refundCharge', { chargeId, refundAmount });
      if (errorCode) this.refundState = 'error';
      else this.refundState = 'created';
      return { errorCode };
    },

    async searchChargesByDispatchId(searchObject) {
      this.loadingCharge = true;
      const { data, errorCode } = await this.$store.dispatch('charges/listCharges', { ...searchObject, status: 'captured' });
      this.loadingCharge = false;
      return { data, errorCode };
    },
    async listRefunds() {
      this.refundsLoading = true;
      const { data, headers, errorCode } = await this.$store.dispatch('charges/listCharges', { ...this.refundsSearchObject, status: 'refunded' });
      if (data) {
        this.refunds = data;
      }
      if (errorCode) {
        this.refundsLoading = false;
      }
      this.refundsListInfo = this.formatHeaders(headers);
    },
    formatHeaders(headers) {
      if (!headers) return {};
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};
